import React from "react"
import { CONDITION_DETAILS, FLAG_COUNT_CONDITION_PROPERTY } from "utils/workflowHelpers"
import { snakeToCapitalCase } from "utils/stringHelpers"
import { workflowConditionShape } from "utils/propTypeShapes"
import types from "prop-types"
import { Select } from "shared/selects"
import FormsyValidation from "shared/FormsyValidation"

const OPTIONS = CONDITION_DETAILS[FLAG_COUNT_CONDITION_PROPERTY].operators.map((op) => ({
  value: op,
  label: snakeToCapitalCase(op),
}))

const DefineFlagCountOperator = ({ condition, conditionIndex, changeConditionOperator }) => (
  <span className="relative">
    <span className="flex items-center gap-2">
      is
      <Select
        backspaceDelete={false}
        style={{ height: "32px" }}
        onChange={changeConditionOperator}
        options={OPTIONS}
        placeholder="Select operator ... *"
        required
        value={condition.operator}
        label="select operator for flag count condition"
      />
    </span>
    <FormsyValidation
      name={`conditions[${conditionIndex}].operator`}
      value={condition?.operator ?? ""}
      validations={{ isNotBlankString: true }}
      validationErrors={{ isDefaultRequiredValue: "required" }}
    />
  </span>
)

DefineFlagCountOperator.propTypes = {
  condition: workflowConditionShape.isRequired,
  changeConditionOperator: types.func.isRequired,
  conditionIndex: types.number.isRequired,
}

export default DefineFlagCountOperator
